import { Badge } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { EScreeningHistoryStatus } from '../model'
import type { TScreeningHistoryStatus } from '../model'

const statusStyles: Record<
  TScreeningHistoryStatus,
  { bg: string; color: string }
> = {
  [EScreeningHistoryStatus.SUITABLE]: {
    bg: 'badge.green.20',
    color: 'badge.green.100',
  },
  [EScreeningHistoryStatus.DEFERRED]: {
    bg: 'badge.red.20',
    color: 'badge.red.100',
  },
}

const statusLabelKeys: Record<TScreeningHistoryStatus, string> = {
  [EScreeningHistoryStatus.SUITABLE]: 'screening.history_status.suitable',
  [EScreeningHistoryStatus.DEFERRED]: 'screening.history_status.deferred',
}

interface Props {
  status: TScreeningHistoryStatus
}

export function ScreeningHistoryStatusBadge({ status }: Props) {
  const { t } = useTranslation()
  const { bg, color } = statusStyles[status]

  return (
    <Badge
      px={2}
      py={0.5}
      borderRadius="md"
      fontSize="xs"
      w="fit-content"
      bg={bg}
      color={color}
    >
      {t(statusLabelKeys[status])}
    </Badge>
  )
}
